module.exports = __webpack_public_path__ + "static/img/mapofChina.9d9afe3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mapofChina.jpg
// module id = NLK8
// module chunks = 1